// extracted by mini-css-extract-plugin
export default {"menuModalLabel":"MenuModal_menuModalLabel__LHdtr","menuModalLabelList":"MenuModal_menuModalLabelList__MsNid","menuModalLabelInput":"MenuModal_menuModalLabelInput__ST6Ov"};